function is_true(boolean_test) {
    return (boolean_test + "" === true + "");
}
export default is_true;
